import { makeObservable, observable } from "mobx";
import { IPOW3Fetchers } from "../../network/fetchers/POW3Fetchers";
import { Environment } from "../../network/domain/Environment";

export interface IOtherEnvironmentsStore {
    otherEnvironments: Environment[];
    getOtherActiveEnvironments(): Promise<void>;
}

export class OtherEnvironmentsStore implements IOtherEnvironmentsStore {
    constructor(private readonly pow3Fetchers: IPOW3Fetchers) {
        makeObservable(this);
    }

    @observable
    public otherEnvironments: Environment[] = [];
    
    public async getOtherActiveEnvironments(): Promise<void> {
        const result = await this.pow3Fetchers.getAllEnvironments(true);
        if (result.allOk) {
            this.otherEnvironments = result.environments?.filter((x) => !x.inactive);
        }
    }
}
